export const modalInnerStyle = {
  width: 400,
  bgcolor: 'background.paper',
  margin: 'auto',
  borderRadius: '16px',
  boxShadow: 'rgb(0 0 0 / 20%) 0px 11px 15px -7px, rgb(0 0 0 / 14%) 0px 24px 38px 3px, rgb(0 0 0 / 12%) 0px 9px 46px 8px',
  padding: '24px'
};

export const modalHeaderProps = {
  align: 'center',
  variant: 'h1',
  component: 'h1'
};
